module.exports = __webpack_public_path__ + "media/images/emblems/Berg(Turgovio)-Blazono-273039c6536cf2810bbdbb5b5c7aa4ff.png";